var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFilterIconAppliedTranHistory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.565 1C1.701 1 1 1.713 1 2.59v.936c0 .65.247 1.276.69 1.746l4.845 5.152.002-.003A5.157 5.157 0 018 14.023v4.572c0 .306.32.5.585.357l2.76-1.504c.416-.228.676-.67.676-1.15v-2.287c0-1.342.519-2.631 1.446-3.587l4.846-5.152c.44-.47.688-1.096.688-1.746V2.59C19 1.713 18.3 1 17.436 1H2.566z",
    fill: "#ED1B2E",
    stroke: "#ED1B2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgFilterIconAppliedTranHistory;